<template>
  <section>
      <div class="d-flex justify-content-start align-items=end mb-2">
        <b-form-group label="PO No." class="mr-2">
          <b-form-input v-model="filterObj.purchaseOrderNumber" @input="onFilter"></b-form-input>
        </b-form-group>
        <b-form-group label="Part Number" class="mr-2">
          <b-form-input v-model="filterObj.partNumber" @input="onFilter"></b-form-input>
        </b-form-group>
        <div class="clear-filter-button-container mt-3">
          <b-button size="sm" @click="onClearFilter">Clear filters</b-button>
        </div>
      </div>
      <grid-component
        isResizable
        isReorderable
        :canEdit="checkClaim(CAN_EDIT_POS)"
        :canDelete="checkClaim(CAN_DELETE_POS)"
        :gridId="gridId"
        :pageable="pageable"
        :itemData="itemData"
        :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
        :take="pageInfo.pageSize"
        :pageSizes="pageInfo.pageSize"
        :totalItems="pageInfo.totalItems"
        :sortBy="pageInfo.sortBy"
        :sortOrder="pageInfo.sortOrder"
        :sortMethod="sortGrid"
        :fields="fields"
        :onEdit="pushToDetails"
        :onDelete="onDelete"
        :handleRowClick="onRowClick"
        :navigationField="'purchaseOrderId'"
        :isTblLoader="tblLoader"
        :styleCustom="'height: 210px'"
        @getData="onGetData"
      />
  </section>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import debounce from 'lodash/debounce';
import { SORT_ORDER, GRID_PAGE_SIZES, PAGE_SIZE, GRID_ID, SEARCH_DEBOUNCE_TIME } from '@/shared/constants';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from './fields';

export default {
  components: {
    GridSettings,
    GridComponent
  },
  props: {
    companyId: {
      type: [Number, String],
      default: 0,
    },
    partId: {
      type: [String, Number],
      default: 0,
    }
  },
  data() {
    return {
      filtersVisible: false,
      fields: gridFields,
      gridId: GRID_ID.PURCHASE_ORDER_LINES_TAB_GRID,
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
      selectedRowItemId: 0,
      filterObj: {}
    };
  },
  computed: {
    ...mapGetters('purchaseOrderLinesComponent', ['purchaseOrderLines','pageInfo', 'filters', 'tblLoader']),
    ...mapGetters('account', ['gridSettingsById']),
    itemData() {
      return this.purchaseOrderLines;
    },
  },
  methods: {
    ...mapMutations('purchaseOrderLinesComponent', ['setItem']),
    ...mapActions('purchaseOrderLinesComponent', ['getAll', 'sortGrid']),
    ...mapActions('purchaseOrderLines', ['deletepurchaseOrderLine']),
    onRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
    },
    onFilter: debounce(function() {
      this.setItem({ resource: 'pageInfo', payload: {...this.pageInfo, pageNumber: 1}});
      this.setItem({ resource: 'filters', payload: {...this.filters, ...this.filterObj} });
    }, SEARCH_DEBOUNCE_TIME),
    onClearFilter() {
      this.clearObject(this.filterObj);
      this.onFilter();
    },
    pushToDetails(row) {
      this.$router.push({
        name: 'purchaseorders.edit',
        params: { id: row.purchaseOrderId },
      });
    },
    async onDelete(item) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete purchaseOrder line?`});
      if (deleteConfirmed) {
        const result = await this.deletepurchaseOrderLine(item.id).then(() => this.getAll({}));
        
      }
    },
    async onGetData(params) {
      await this.getAll(params);
    },
  },
  watch: {
    companyId() {
      this.setItem({ resource: 'filters', payload: {...this.filters, companyId: this.companyId} });
    },
    partId() {
      this.setItem({ resource: 'filters', payload: {...this.filters, partId: this.partId} });
    },
    filters() {
      this.getAll({});
    }
  },
  mounted() {
    this.setItem({resource: 'filters', payload: { companyId: this.companyId, partId: this.partId }});
    // this.getpurchaseOrderLines({});  
  }
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';

.highlight {
  background: $rowSelection !important;
}

.b-pagination {
  justify-content: center;
}

.tools > * {
  margin: 0 0 0 3px;
}

#KendoGrid .k-virtual-scrollable-wrap table {
  min-width: 800px;
}
</style>
